import { createAction } from 'typesafe-actions';
import {
  CssPropertyAnalysisFilter,
  CssPropertyAnalysisFilterOptions,
  CssPropertyAnalysisItem,
  CssPropertyAnalysisPagination,
  CssPropertyAnalysisSummary,
  CssDatasetDecision,
  CssResolvableField,
} from 'types/PropertyAnalysis';

export const doPropertyAnalysisLoad = createAction('@PROPERTY_ANALYSIS/LOAD')<{
  filter?: Partial<CssPropertyAnalysisFilter>;
  page?: number;
}>();

export const doPropertyAnalysisFilterOptionsLoad = createAction(
  '@PROPERTY_ANALYSIS/FILTER_OPTIONS_LOAD',
)();

export const doPropertyAnalysisFilterOptionsLoadSuccess = createAction(
  '@PROPERTY_ANALYSIS/FILTER_OPTIONS_LOAD_SUCCESS',
)<{ filterOptions: CssPropertyAnalysisFilterOptions }>();

export const doPropertyAnalysisFilterOptionsLoadFailure = createAction(
  '@PROPERTY_ANALYSIS/FILTER_OPTIONS_LOAD_FAILURE',
)<{ error: string }>();

export const doPropertyAnalysisFilterOpenModal = createAction(
  '@PROPERTY_ANALYSIS/FILTER_OPEN_MODAL',
)();
export const doPropertyAnalysisLoadSuccess = createAction(
  '@PROPERTY_ANALYSIS/LOAD_SUCCESS',
)<{
  items: CssPropertyAnalysisItem[];
  summary: CssPropertyAnalysisSummary;
  pagination: CssPropertyAnalysisPagination;
  append: boolean;
}>();

export const doPropertyAnalysisLoadFailure = createAction(
  '@PROPERTY_ANALYSIS/LOAD_FAILURE',
)<{ error: string; page: number }>();

export const doPropertyAnalysisExport = createAction(
  '@PROPERTY_ANALYSIS/EXPORT',
)();

export const doPropertyAnalysisExportSuccess = createAction(
  '@PROPERTY_ANALYSIS/EXPORT_SUCCESS',
)();

export const doPropertyAnalysisExportFailure = createAction(
  '@PROPERTY_ANALYSIS/EXPORT_FAILURE',
)<{ error: string }>();

export const doPropertyAnalysisDatasetDecisionUpdate = createAction(
  '@PROPERTY_ANALYSIS/DATASET_DECISION_UPDATE',
)<{ propertyId: string; decision: CssDatasetDecision }>();

export const doPropertyAnalysisDatasetDecisionUpdateSuccess = createAction(
  '@PROPERTY_ANALYSIS/DATASET_DECISION_UPDATE_SUCCESS',
)<{ property: CssPropertyAnalysisItem }>();

export const doPropertyAnalysisDatasetDecisionUpdateFailure = createAction(
  '@PROPERTY_ANALYSIS/DATASET_DECISION_UPDATE_FAILURE',
)<{ propertyId: string; error: string }>();

export const doPropertyAnalysisDerivedFieldUpdate = createAction(
  '@PROPERTY_ANALYSIS/DERIVED_FIELD_UPDATE',
)<{ propertyId: string; field: CssResolvableField; value: string }>();

export const doPropertyAnalysisDerivedFieldUpdateSuccess = createAction(
  '@PROPERTY_ANALYSIS/DERIVED_FIELD_UPDATE_SUCCESS',
)<{ property: CssPropertyAnalysisItem }>();

export const doPropertyAnalysisDerivedFieldUpdateFailure = createAction(
  '@PROPERTY_ANALYSIS/DERIVED_FIELD_UPDATE_FAILURE',
)<{ propertyId: string; error: string }>();

export const doPropertyAnalysisClear = createAction(
  '@PROPERTY_ANALYSIS/CLEAR',
)();
